import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import Select from 'react-select'

// eslint-disable-next-line react/display-name
export default ({ credential, lockedButtons, onSelectInsurance }) => {
  const [config, setConfig] = useState([])

  useEffect(() => {
    const { configuration, listPolicies } = credential
    let config = {
      options: [{ value: '', label: '' }],
      cancellation: {},
      assistance: {},
      cancellationAssistance: {},
    }
    for (let policy of listPolicies) {
      if (configuration && configuration.insurances) {
        const {
          insurances: { cancellation, assistance, cancellationAssistance },
        } = configuration
        if (cancellation === policy.id) {
          config.cancellation = { value: policy.id, label: policy.nombre_comercial }
          continue
        } else if (assistance === policy.id) {
          config.assistance = { value: policy.id, label: policy.nombre_comercial }
          continue
        } else if (cancellationAssistance === policy.id) {
          config.cancellationAssistance = { value: policy.id, label: policy.nombre_comercial }
          continue
        }
      }
      config.options.push({ value: policy.id, label: policy.nombre_comercial })
    }
    setConfig(config)
  }, [credential])

  const onChangeSelect = (policy, event) => {
    setConfig({ ...config, [event.name]: policy })
    onSelectInsurance(event.name, policy.value)
  }

  return (
    <>
      <Row>
        <Col xs={2} />
        <Col xs={8}>
          <FormGroup>
            <label htmlFor='cancellation'>{I18n.t('dashboard_annulment')}</label>
            <Select id='cancellation' name='cancellation' value={config.cancellation} options={config.options} onChange={onChangeSelect} />
          </FormGroup>
        </Col>
        <Col xs={2} />
      </Row>
      <Row>
        <Col xs={2} />
        <Col xs={8}>
          <FormGroup>
            <label htmlFor='assistance'>{I18n.t('dashboard_assistance-without-cancellation')}</label>
            <Select id='assistance' name='assistance' value={config.assistance} options={config.options} onChange={onChangeSelect} />
          </FormGroup>
        </Col>
        <Col xs={2} />
      </Row>
      <Row>
        <Col xs={2} />
        <Col xs={8}>
          <FormGroup>
            <label htmlFor='cancellationAssistance'>{I18n.t('dashboard_assistance-with-cancellation')}</label>
            <Select
              id='cancellationAssistance'
              name='cancellationAssistance'
              value={config.cancellationAssistance}
              options={config.options}
              onChange={onChangeSelect}
            />
          </FormGroup>
        </Col>
        <Col xs={2} />
      </Row>
    </>
  )
}
